import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between border-b border-catering-cream-300 bg-catering-cream-50 px-3 py-2" }
const _hoisted_2 = { class: "flex min-w-0 items-center gap-2.5" }
const _hoisted_3 = {
  class: "flex h-8 w-8 shrink-0 items-center justify-center rounded-catering-md bg-gradient-to-br from-catering-lemon to-catering-lemon-300 shadow-catering-xs",
  "aria-hidden": "true"
}
const _hoisted_4 = { class: "min-w-0" }
const _hoisted_5 = { class: "text-[10px] font-semibold uppercase tracking-[0.14em] text-catering-honey-500" }
const _hoisted_6 = { class: "truncate text-sm font-bold text-catering-ink-900" }
const _hoisted_7 = { class: "flex shrink-0 items-center gap-1" }
const _hoisted_8 = ["aria-label", "title", "onClick"]

import { computed } from 'vue'
import { SparklesIcon } from '@heroicons/vue/24/solid'
import {
  ClockIcon,
  PencilSquareIcon,
  ArrowsPointingOutIcon,
  ArrowsPointingInIcon,
  MinusIcon
} from '@heroicons/vue/24/outline'
import { botHeaderActions } from '@/config/botHeaderActions'
import { botWidgetCopy } from '@/config/botWidgetCopy'


export default {
  __name: 'BotHeader',
  props: {
  title: { type: String, default: 'Bottle Bot' },
  mode: { type: String, default: 'open' },
  platform: { type: String, default: 'catering' }
},
  emits: ['history', 'new', 'expand', 'minimize', 'hide'],
  setup(__props) {

const props = __props

const actions = computed(() => botHeaderActions(props.mode))
const eyebrow = computed(() => botWidgetCopy(props.platform).eyebrow)
const icons = {
  history: ClockIcon,
  new: PencilSquareIcon,
  expand: ArrowsPointingOutIcon,
  minimize: ArrowsPointingInIcon,
  hide: MinusIcon
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_unref(SparklesIcon), { class: "h-5 w-5 text-catering-ink-900" })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(eyebrow.value), 1),
        _createElementVNode("h2", _hoisted_6, _toDisplayString(__props.title), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actions.value, (action) => {
        return (_openBlock(), _createElementBlock("button", {
          key: action.key,
          type: "button",
          "aria-label": action.label,
          title: action.label,
          class: _normalizeClass(["rounded-catering-sm p-1.5 text-catering-ink-500 hover:bg-catering-cream-200 hover:text-catering-ink-900", { 'max-[576px]:hidden': action.hideOnMobile }]),
          onClick: $event => (_ctx.$emit(action.key))
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(icons[action.key]), { class: "h-4 w-4" }))
        ], 10, _hoisted_8))
      }), 128))
    ])
  ]))
}
}

}